import React from 'react';
import { connect } from 'react-redux';
import { FormControl, FormLabel } from '@mui/material';
import { setEquipDisplayOption } from '../../../redux/actions/ui';
import Selector from '../../util/Selector';

import './filters.css';

const OPTIONS = [
  { key: 'name', id: 'name', display: 'Equipment Name' },
  { key: 'sensor', id: 'sensor', display: 'Sensor Type' },
];

const ByEquipOptionsView = ({ value, handleChange }) => (
  <FormControl component="fieldset" className="filter-outer">
    <FormLabel component="legend" className="legend">
      Group By:
    </FormLabel>
    <Selector options={OPTIONS} selected={value} onChange={handleChange} />
  </FormControl>
);

export default connect(
  ({ ui: { byEquipDisplayOption } }) => ({
    value: byEquipDisplayOption,
  }),
  (dispatch) => ({
    handleChange: (e) => dispatch(setEquipDisplayOption(e.target.value)),
  })
)(ByEquipOptionsView);
